import React from 'react';
import CheckoutConfiguratorAnalytics from "../../../_modules/google_analytics/checkout_configurator";
import Translation from "../translation/translation";

export default function CantProvideVehicle(props) {
    const onChange = () => {
        CheckoutConfiguratorAnalytics.cannotProvideVehicleLinkClickAction();
        props.onChangeCantProvideVehicle();
    };

    return (<>
        <div className='configuartor-not-provide-data' onClick={onChange}>
            <label htmlFor={props.id} style={{ fontWeight: '500', marginLeft: '5px', fontSize: '16px', textDecoration: 'underline', cursor: 'pointer' }}>
                <Translation translationKey={'vehicle-configurator-sorry-can-not-provide-vehicle-text'} />
            </label>
        </div>
    </>);
}